import { Button, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React, { useState } from 'react';
import { IAppCustomer } from '../../Interfaces/Application/IAppCustomer';
import { useDialog } from '../../providers/DialogProvider';
import { DialogProps } from './DialogProps';
import { hasValue } from "@amsanalytics/react-shared-library";

export interface ApplicationReportDialogProps extends DialogProps<string> {
  appCustomers: IAppCustomer[];
}

export default function ApplicationReportDialog(props: ApplicationReportDialogProps) {
  const [openDialog, closeDialog] = useDialog();
  const [selectedCustomerId, setSelectedCustomerId] = useState<string>('');
  return (
    <>
      <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
        Credit Application
      </DialogTitle>
      <DialogContent>
        <p>Choose a customer you would like to view credit for.</p>
        <FormControl component='fieldset'>
          <FormLabel component='legend'>Customer</FormLabel>
          <RadioGroup aria-label='application customer' name='gender1' value={selectedCustomerId} onChange={(e) => setSelectedCustomerId(e.target.value)}>
            {
                props.appCustomers.map((customer: IAppCustomer) => {
                    return <FormControlLabel value={customer.customerId} control={<Radio />} label={`${customer.customer.firstName} ${customer.customer.lastName}`} />;
                })
            }
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={closeDialog} color='primary'>
          Cancel
        </Button>
        <Button
          disabled={!hasValue(selectedCustomerId)}
          onClick={() =>
            {
              closeDialog(); 
              props.accept && props.accept(selectedCustomerId)}
            }
          color='primary'
        >
          View
        </Button>
      </DialogActions>
    </>
  );
}
